<template>
  <footer class="app-footer">
    <div class="container app-footer__inner">
      <div class="app-footer__brand">
        <div class="app-footer__title">Slackline TJS</div>
        <div class="app-footer__copy">{{ tOr('common.footer_copy', 'Información legal y preferencias de privacidad') }}</div>
      </div>

      <nav class="app-footer__links" aria-label="Legal">
        <router-link class="app-footer__link" to="/legal/privacy-policy">
          {{ tOr('common.privacy_policy_link', 'Política de privacidad') }}
        </router-link>
        <router-link class="app-footer__link" to="/legal/cookies-policy">
          {{ tOr('common.cookies_policy_link', 'Política de cookies') }}
        </router-link>
        <router-link class="app-footer__link" to="/legal/terms-conditions">
          {{ tOr('common.terms_conditions_link', 'Términos y condiciones') }}
        </router-link>
        <button v-if="isAuthenticated" type="button" class="app-footer__button" @click="openPreferences">
          {{ tOr('common.cookie_preferences_link', 'Preferencias de cookies') }}
        </button>
      </nav>
    </div>
  </footer>
</template>

<script>
import { mapActions, mapState } from 'vuex';

export default {
  name: 'AppFooter',
  computed: {
    ...mapState('user', ['isAuthenticated']),
  },
  methods: {
    ...mapActions('cookieConsent', ['openPreferences']),
    tOr(key, fallback) {
      return typeof this.$te === 'function' && this.$te(key) ? this.$t(key) : fallback;
    },
  },
};
</script>

<style scoped>
.app-footer {
  margin-top: 2.5rem;
  padding: 1.25rem 0 1.75rem;
  border-top: 1px solid rgba(148, 163, 184, 0.24);
  background: linear-gradient(180deg, rgba(248, 250, 252, 0.7), rgba(255, 255, 255, 0.94));
}

.app-footer__inner {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 1rem;
  flex-wrap: wrap;
}

.app-footer__title {
  font-weight: 700;
  color: #0f172a;
}

.app-footer__copy {
  font-size: 0.92rem;
  color: #64748b;
}

.app-footer__links {
  display: flex;
  gap: 1rem;
  flex-wrap: wrap;
  align-items: center;
}

.app-footer__link,
.app-footer__button {
  color: #0f766e;
  text-decoration: none;
  background: none;
  border: none;
  padding: 0;
  font: inherit;
}

.app-footer__link:hover,
.app-footer__button:hover {
  text-decoration: underline;
}
</style>